<template>
  <div class="devicesModel app-container">
    <div class="global-header-wrap">
      <h3>设备型号标签管理</h3>
    </div>
    <el-card class="app-table-container" :body-style="{ padding: '20px' }">
      <div slot="header">
        <div class="global-table-header">
          <div class="devicesModel-header-btn-left">
            <list-search ref="listSearch" @listSearchEvn="listSearchFun" />
          </div>
          <div class="devicesModel-header-right">
            <button
              class="global-button-style"
              @click="$router.push({ name: 'createDevicesModelTag' })"
            >
              新增设备型号标签
            </button>
          </div>
        </div>
      </div>
      <div class="global-body-wrap">
        <appTable
          :tableData="tableData"
          :tableProps="tableProps"
          :selectCtrl="false"
          @tableHandle="tableHandle"
        />
      </div>
      <pagination
        :pageSize="params.limit"
        :total="total"
        @pageNum="getPageNum"
      />
    </el-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import listSearch from "@/components/listSearch";
import appTable from "@/components/appTable";
import pagination from "@/components/pagination";
import listMixin from "@/mixins/list";
export default {
  components: {
    listSearch,
    appTable,
    pagination,
  },
  computed: {
    ruleProps() {
      let ruleProps = [
        {
          prop: "name",
          label: this.$t("org.tagName"),
          placeholder: this.$t("placeholder.tagName"),
        },
        {
          prop: "models",
          label: "设备型号(多种型号用\\隔开)",
          placeholder: "请输入设备型号",
        },
      ];
      return ruleProps;
    },
    rules() {
      let rules = {
        name: [
          { required: true, message: this.$t("verify.tag"), trigger: "blur" },
        ],
        // models: [
        //   { required: true, message: this.$t("verify.tag"), trigger: "blur" }
        // ]
      };
      return rules;
    },
    tableProps() {
      let tableProps = [
        {
          prop: "name",
          label: this.$t("org.tagName"),
        },
        {
          prop: "updatedAt",
          label: "创建时间",
        },
        {
          prop: "handle",
          label: this.$t("commonMsg.handle"),
          width: 220,
          btn: [this.$t("commonMsg.edit"), this.$t("commonMsg.del")],
        },
      ];
      return tableProps;
    },
  },
  mixins: [listMixin],
  data() {
    return {
      ruleForm: {
        name: "",
        models: "",
      },
      params: {
        limit: 20,
        page: 1,
        sortBy: "updatedAt",
      },
      tableData: [],
      total: 0,
      title: "",
      tagItem: null,
      centerDialogVisible: false,
    };
  },
  methods: {
    async getList() {
      let res = await this.$http.getModelGroups(this.params);
      this.tableData = res.data.results;
      this.total = res.data.count;
    },

    del(data) {
      this.$http.delModelGroups(data.row._id).then((res) => {
        this.elMsg(this.$t("alertMsg.delSuccess"), "success");
        this.tableData.splice(data.$index, 1);
      });
    },

    edit(data) {
      this.tagItem = data.row;
      this.$router.push({
        name: "createDevicesModelTag",
        query: { id: this.tagItem._id },
      });
    },

    listSearchFun(val) {
      if (val) {
        this.params.name = val;
      } else {
        delete this.params.name;
      }
      this.getList();
    },
  },
};
</script>

<style lang="scss" scoped>
.devicesModel {
  .devicesModel-btn {
    text-align: right;
    padding: 10px;
  }
  .devicesModel-pagination {
    padding: 10px;
    text-align: right;
  }
  .devicesModel-dialog-item {
    padding: 10px 0;
    line-height: 25px;
    > p:first-child {
      font-weight: bold;
    }
  }
}
</style>
